import NanoModal from "./modal";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default function initGalleryModal() {
  const modalTriggers = document.querySelectorAll(".open-gallery-modal");

  modalTriggers.forEach((modalTrigger) => {
    const target = modalTrigger.dataset.modalTarget;
    const modalElement = document.getElementById(target);

    // Variables to store Swiper instances
    let swiperThumbs;
    let swiperMain;

    const modal = new NanoModal(modalElement, {
      onShow: (modalInstance) => {
        // Initialize the Swiper instances when the modal is shown
        const container = modalElement.querySelector(
          ".modal-gallery-container"
        );
        const thumbSlider = container.querySelector(
          ".modal-gallery-slider-thumbs"
        );
        const mainSlider = container.querySelector(".modal-gallery-slider");
        const nextButton = container.querySelector(".swiper-button-next");
        const prevButton = container.querySelector(".swiper-button-prev");

        // Initialize the thumbnail Swiper
        swiperThumbs = new Swiper(thumbSlider, {
          spaceBetween: 12,
          slidesPerView: 5,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            768: {
              spaceBetween: 12,
            },
            1024: {
              spaceBetween: 24,
            },
          },
        });

        // Initialize the main Swiper and link it with the thumbnails
        swiperMain = new Swiper(mainSlider, {
          // spaceBetween: 10,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          autoHeight: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          thumbs: {
            swiper: swiperThumbs,
          },
        });

        // Update modal trigger attributes
        modalTrigger.setAttribute("aria-expanded", "true");
        modalTrigger.classList.add("modal-trigger-open");
      },
      onClose: () => {
        // Destroy the Swiper instances when the modal is closed
        if (swiperMain) {
          swiperMain.destroy();
          swiperMain = null;
        }
        if (swiperThumbs) {
          swiperThumbs.destroy();
          swiperThumbs = null;
        }

        // Update modal trigger attributes
        modalTrigger.setAttribute("aria-expanded", "false");
        modalTrigger.classList.remove("modal-trigger-open");
      },
      closeOnEscape: true,
      closeOnOutsideClick: true,
      disableScrollShift: false,
      disableScroll: true,
      debug: true,
    });

    modalTrigger.addEventListener("click", () => {
      modal.showModal();
    });
  });
}
